export default {

	init() {
		console.log('login init...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	bindEvents() {
		var el = $('.regis-login-form input[type="password"]');
		$('<button class="show-hide-pw" type="button">Show</button>').insertAfter(el);
		$('.show-hide-pw').on('click', function() {
			if($(this).html() == 'Show') {
				$(this).prev('input[type="password"]').prop('type', 'text');
				$(this).html('Hide');
			} else {
				$(this).prev('input[type="text"]').prop('type', 'password');
				$(this).html('Show');
			}
		});

		Login.initModal();
	},

	initModal() {
		var $modal = $('.regis-login-error');
		var $close = $modal.find('[data-error-dismiss]');

		$close.on('click', Login.closeModal);
		Login.toggleModal();
	},

	toggleModal() {
		var $modal = $('.regis-login-error');
		var isModalOpen = $modal.hasClass('show');

		if (isModalOpen) {
			$modal.attr('role', 'dialog');
			$modal.attr('aria-modal', 'true');
		} else {
			$modal.removeAttr('role');
			$modal.removeAttr('aria-modal');
		}
	},

	closeModal() {
		var $modal = $('.regis-login-error');
		var $close = $modal.find('[data-error-dismiss]');
		$modal.removeClass('show');
		$modal.addClass('fade');
		$close[0].blur();

		setTimeout(function() {
			$modal.addClass('hidden');
			Login.toggleModal();
		}, 300);
	}
}